import { PanelLeft, PanelLeftDashed, Sun, Moon, LogOut } from "lucide-react";

/**
 * Header component for the admin dashboard
 * @param {Object} props - Component props
 * @param {boolean} props.sidebarExpanded - Whether the sidebar is expanded
 * @param {Function} props.toggleSidebar - Function to toggle sidebar
 * @param {string} props.theme - Current theme ('light' or 'dark')
 * @param {Function} props.toggleTheme - Function to toggle theme
 * @param {Function} props.handleLogout - Function to handle logout
 * @returns {JSX.Element} Rendered Header component
 */
const Header = ({
  sidebarExpanded,
  toggleSidebar,
  theme,
  toggleTheme,
  handleLogout,
  title = ""
}) => {
  return (
    <div className="flex items-center justify-between px-6 py-3 border-b border-bd-50">
      <div className="flex items-center gap-3">
        <button
          onClick={toggleSidebar}
          className="p-2 text-fg-60 hover:text-fg-50 transition-colors"
        >
          {sidebarExpanded ? (
            <PanelLeftDashed size={20} />
          ) : (
            <PanelLeft size={20} />
          )}
        </button>
        {title && <h2 className="text-xl font-medium">{title}</h2>}
      </div>
      <div className="flex items-center gap-2">
       
        <button
          onClick={toggleTheme}
          className="p-2 rounded-full text-fg-60 hover:text-fg-50 transition-colors"
          aria-label="Toggle theme"
        >
          {theme === "light" ? <Moon size={18} /> : <Sun size={18} />}
        </button>
        <button
          className="p-2 rounded-full text-fg-60 hover:text-fg-50 transition-colors"
          aria-label="Logout"
          onClick={handleLogout}
        >
          <LogOut size={18} />
        </button>
      </div>
    </div>
  );
};

export default Header;
